import {gql} from '@apollo/client';
import { DELIVERY_TASK_ORDER_FIELDS, DeliveryTaskOrderType } from '../types/DeliveryTaskOrderType';

export const GET_DELIVERY_TASK_ORDER_LIST = gql`
  query DeliveryQuery($maxDeliveryTaskId: Long!, $startTimestamp: Long, $endTimestamp: Long) {
    getDeliveryTaskOrderList(maxDeliveryTaskId: $maxDeliveryTaskId, startTimestamp: $startTimestamp, endTimestamp: $endTimestamp) {
      maxDeliveryTaskId
      deliveryTaskOrderList {
        ...DeliveryTaskOrderFields
      }
      podAbnormalOrderList{
          id
          orderId
          routeName
          stopNumber
          trackingNumber
          podUpdateTimeString
          isAllowUpdatePod
          isPopUp
          updatedAt
          deliveredDriverAccountName
          orderWithAddress {
              deliveryAddress {
                  addressLine1
                  addressLine2
                  city
                  company
                  countryCode
                  email
                  extension
                  fullName
                  id
                  instructions
                  phoneNumber
                  state
                  zipcode
              }
              order {
                  deliverAt
                  deliveredAt
                  preDeliveredAt
                  deliveryAttempts
                  isDelivered
                  isFinished
                  orderTime
                  id
                  trackingNumber
                  podReviewStatus
                  podReviewMessage {
                    id
                    failureOtherReason
                    lang
                    translateFailureOtherReason {
                      lang
                      translateFailureOtherReason
                    }
                  }
                  podReviewReasons {
                    l1Code
                    l1Label {
                      zh
                      en
                      es
                    }
                    driverNotification {
                      zh
                      en
                      es
                    }
                    l2Reasons {
                      l2Code
                      l2Label {
                        zh
                        en
                        es
                      }
                      isLegacy
                    }
                  }
                  podImageS3KeysJson
                  podImageS3UrlsJson
                  podHasBeenManualDisapproved
                  isModifiedPodPhotos
              }
          }
      }
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;

export const GET_NEW_DELIVERY_TASK_ORDER_LIST = gql`
  query DeliveryQuery($maxDeliveryTaskId: Long!, $startTimestamp: Long, $endTimestamp: Long) {
    getNewDeliveryTaskOrderList(maxDeliveryTaskId: $maxDeliveryTaskId, startTimestamp: $startTimestamp, endTimestamp: $endTimestamp) {
      maxDeliveryTaskId
      deliveryTaskOrderList {
        ...DeliveryTaskOrderFields
      }
      podAbnormalOrderList{
          id
          orderId
          routeName
          stopNumber
          trackingNumber
          podUpdateTimeString
          isAllowUpdatePod
          isPopUp
          updatedAt
          deliveredDriverAccountName
          orderWithAddress {
              deliveryAddress {
                  addressLine1
                  addressLine2
                  city
                  company
                  countryCode
                  email
                  extension
                  fullName
                  id
                  instructions
                  phoneNumber
                  state
                  zipcode
              }
              order {
                  deliverAt
                  deliveredAt
                  preDeliveredAt
                  deliveryAttempts
                  isDelivered
                  isFinished
                  orderTime
                  id
                  trackingNumber
                  podReviewStatus
                  podReviewMessage {
                    id
                    failureOtherReason
                    lang
                    translateFailureOtherReason {
                      lang
                      translateFailureOtherReason
                    }
                  }
                  podReviewReasons {
                    l1Code
                    l1Label {
                      zh
                      en
                      es
                    }
                    driverNotification {
                      zh
                      en
                      es
                    }
                    l2Reasons {
                      l2Code
                      l2Label {
                        zh
                        en
                        es
                      }
                      isLegacy
                    }
                  }
                  podImageS3KeysJson
                  podImageS3UrlsJson
                  podHasBeenManualDisapproved
                  isModifiedPodPhotos
              }
          }
      }
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;

export interface DeliveryTaskOrderListResponse {
    getDeliveryTaskOrderList: {
        maxDeliveryTaskId: number;
        deliveryTaskOrderList: DeliveryTaskOrderType[];
        podAbnormalOrderList: DeliveryTaskOrderType[];
    }
}

export interface NewDeliveryTaskOrderListResponse {
    getNewDeliveryTaskOrderList: {
        maxDeliveryTaskId: number;
        deliveryTaskOrderList: DeliveryTaskOrderType[];
        podAbnormalOrderList: DeliveryTaskOrderType[];
    }
}

export interface OtherDriverDeliveryTaskOrderType {
    stopNumber: number;
    subStopNumber?: string | null;
    routeName: string;
    trackingNumber: string;
}

export const GET_NEW_ASSIGNMENT_CONFIRM_LIST = gql`
  query DeliveryQuery {
    getNewAssignmentConfirmList {
      totalNeedScanCount
      scannedSuccessCount
      currentDriverUnScanList {
        ...DeliveryTaskOrderFields
      }
      currentDriverUnScanDisplayList
      otherDriverDeliveryTaskOrderList {
        stopNumber
        subStopNumber
        routeName
        trackingNumber
      }
      otherDriverDeliveryTaskOrderDisplayList
    }
  }
  ${DELIVERY_TASK_ORDER_FIELDS}
`;

export interface NewAssignmentConfirmListResponse {
    getNewAssignmentConfirmList: {
        totalNeedScanCount: number;
        scannedSuccessCount: number;
        currentDriverUnScanList: DeliveryTaskOrderType[];
        currentDriverUnScanDisplayList: string[];
        otherDriverDeliveryTaskOrderList: OtherDriverDeliveryTaskOrderType[];
        otherDriverDeliveryTaskOrderDisplayList: string[];
    };
}